const NON_ALPHANUMERIC_RUN = /[^a-z0-9]+/g;

export const toKebabCase = (value: string): string =>
  value.toLowerCase().replace(NON_ALPHANUMERIC_RUN, "-").replace(/^-|-$/g, "");
